import { useEffect, useState } from "react";

import "common/css/master.css";

const SubstitutionDutyTbl = (props) => {
    console.log(props)
    const { lstTchSubsDuty, activeTab, tchId, setTchId, substitutionDt, setSubstitutionDt, openSubstituionDetails } = props;

    const [lstTchSubsDutyFiltered, setLstTchSubsDutyFiltered] = useState([]);
    const [teacherFiltered, setTeacherFiltered] = useState("");

    useEffect(() => {
        // console.log("useEffect in SubstitutionDutyTbl component called, lstTchSubsDuty", props.lstTchSubsDuty);
        setTeacherFiltered("");

        setLstTchSubsDutyFiltered(lstTchSubsDuty);
    }, [lstTchSubsDuty, activeTab]);

    const handleFilterTeacher = async (fTeacher) => {
        // console.log("handleFilterTeacher called with:", fTeacher);
        await setTeacherFiltered(fTeacher);
        filterTeacherTable(fTeacher.trim().toLowerCase());
    }

    const filterTeacherTable = (fTeacher) => {
        // console.log("filterTeacherTable called with:", fTeacher, "lstTchSubsDuty:", lstTchSubsDuty);
        const filtered = lstTchSubsDuty.filter(item => item.tch.toLowerCase().includes(fTeacher));
        setLstTchSubsDutyFiltered(filtered);
    }

    const colgrp = (!activeTab || activeTab === 'daily') ? <colgroup>
        <col width="60"></col>
        <col width="80"></col>
        <col width="40"></col>
    </colgroup> :
        <colgroup>
            <col width="80"></col>
            <col width="40"></col>
        </colgroup>



    return (
        <div className="col-sm-12 padding-remove">
            <div className="col-sm-12 padding-remove">
                <table className="tableLayout1" >
                    {colgrp}
                    <thead>
                        <tr>
                            <th className={activeTab == 'daily' ? 'text-left' : 'no-display'}>Date</th>
                            <th >
                                <input
                                    type="text" className="form-control inp-search"
                                    value={teacherFiltered}
                                    onChange={(e) => handleFilterTeacher(e.target.value)}
                                    name="teacher name"
                                    placeholder="Teacher" />
                            </th>
                            <th>Count</th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "60vh" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody id="diaryMonthlyTeacherAllocationTable" >
                            {lstTchSubsDutyFiltered &&
                                lstTchSubsDutyFiltered.map((item, i) => (
                                    <tr key={item.tchId + "-" + item.subsDt}
                                        onClick={() => { setTchId(item.tchId); setSubstitutionDt(item.subsDt); }}
                                        className={item.tchId === tchId && item.subsDt === substitutionDt ? "selected" : ''}>
                                        <td className={activeTab == 'daily' ? 'text-left' : 'no-display'}>{item.subsDt}</td>
                                        <td className="text-left">{item.tch}</td>
                                        <td className="text-center" >{item.countPeriod}</td>
                                        {/* <td className="text-center" >
                                            <span
                                                onClick={() => openSubstituionDetails(item.tchId)}
                                                title="View Substitution Details"
                                                style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                                            >
                                                {item.countPeriod}
                                            </span>
                                        </td> */}
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );

}

export default SubstitutionDutyTbl;